// extracted by mini-css-extract-plugin
export default {"wrapper":"ForecastDay_wrapper__yotwn"};